<template>
  <b-container>
    <b-row>
      <b-col cols="12">
        <h3>{{ $t('LNG_DISCIPLINE_MANAGEMENT_TITLE', this.lang) }}</h3>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <v-client-table ref="disciplinesTable" :data="disciplinesData" :columns="disciplinesColumns" :options="disciplinesOptions">
           <div slot="disabled" slot-scope="props" class="fa" v-bind:class="{'fa-minus-circle': props.row.disabled === '1', 'fa-check-circle': props.row.disabled === '0'}" v-on:click="changeStatus(props.row.id)" style="cursor: pointer;"></div>
           <div slot="editDiscipline" slot-scope="props" class="fa fa-edit" v-on:click="disciplineRowClick(props)" style="cursor: pointer;"></div>
        </v-client-table>
      </b-col>
    </b-row>
    
     <b-modal v-model="disciplineEditionModal" effect="fade" :title="disciplineTitle" @shown="setModalInputFocus">
       <div class="alert alert-danger" role="alert" v-if="showDisciplineUpdateError">
          {{ this.updateDisciplineErrorMessage }}
       </div>
       <b-form @submit="createUpdateNewDiscipline">
         <b-form-input ref="name" v-model="name" type="text" required :placeholder="$t('LNG_NAME_DISCIPLINE', this.lang)" class="mb-3" />
         <b-form-select v-model="selectYearGroup.value" :options="selectYearGroup.options" class="mb-3" required></b-form-select>
         <b-form-select v-model="selectLevelGroup.value" :options="selectLevelGroup.options" class="mb-3" required></b-form-select>
         <b-form-select v-if="this.adminLevel & 4" v-model="selectCenterGroup.value" :options="selectCenterGroup.options" class="mb-3" required></b-form-select>
         <b-button type="button" v-on:click.prevent="exitNewDisciplineModal()">{{ $t('LNG_CLOSE', lang) }}</b-button>
         <b-button variant="evaobj" type="submit"><span v-if="this.selectedDiscipline === 0"> {{$t('LNG_CREATE', this.lang)}}</span><span v-if="this.selectedDiscipline !== 0">{{ $t('LNG_SAVE', this.lang) }}</span></b-button>
       
       </b-form>
       <div slot="modal-footer">
       </div>
   </b-modal>
  </b-container>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
// const constDateFormat = 'DD.MM.YYYY'
export default {
  name: 'managementDiscipline',
  components: {
  },
  data () {
    return {
      selectCenterGroup: {
        options: [],
        value: null
      },
      selectYearGroup: {
        options: [{value: null, text: this.$t('LNG_SELECT_YEAR', this.lang)}, {value: 2017, text: '2017'}, {value: 2018, text: '2018'}, {value: 2019, text: '2019'}],
        value: null
      },
      selectLevelGroup: {
        options: [{value: null, text: this.$t('LNG_SELECT_LEVEL', this.lang)}, {value: 1, text: '1'}, {value: 2, text: '2'}],
        value: null
      },
      name: '',
      center: '',
      level: '',
      year: '',
      updateDisciplineErrorMessage: '',
      showDisciplineUpdateError: false,
      disciplineEditionModal: false,
      selectedDiscipline: 0,
      disciplinesData: [],
      newDisciplineFormIsValid: true,
      disciplinesColumns: ['name', 'center', 'level', 'year', 'disabled', 'editDiscipline'],
      disciplinesOptions: {
        headings: {
          name: this.$t('LNG_NAME_TEACHER', this.lang),
          center: this.$t('LNG_CENTER_NAME', this.lang),
          level: this.$t('LNG_LEVEL', this.lang),
          year: this.$t('LNG_YEAR', this.lang),
          disabled: this.$t('LNG_STATUS', this.lang),
          editDiscipline: this.$t('LNG_EDIT', this.lang)
        },
        filterByColumn: true,
        perPage: 1000,
        perPageValues: [10, 25, 50, 100, 250, 500, 1000],
        texts: this.$parent.tableTexts,
        sortIcon: { base: 'glyphicon', up: 'glyphicon-chevron-up', down: 'glyphicon-chevron-down', is: 'glyphicon-sort' },
        filterable: ['name', 'center', 'level', 'year'],
        sortable: ['name', 'center', 'level', 'year']
      },
      disciplineTitle: this.$t('LNG_NEW_DISCIPLINE', this.lang)
    }
  },
  mounted: function () {
    moment.locale('fr-ch')
    this.loadDisciplines()
    this.loadCenters()
  },
  computed: {
    ...mapState([
      'api',
      'fullname',
      'lang'
    ]),
    adminLevel () {
      return this.$store.getters.adminLevel
    }
  },
  methods: {
    setModalInputFocus (event) {
      this.$refs.name.focus()
    },
    back: function () {
      this.$router.push({ path: '/' })
    },
    loadCenters: function () {
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'loadActiveCenters'
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        while (this.selectCenterGroup.options.length > 0) {
          this.selectCenterGroup.options.pop()
        }
        this.selectCenterGroup.options.push({value: null, text: this.$t('LNG_SELECT_CENTER_DISCIPLINE_GROUP_DEFAULT', this.lang)})
        response.data.centers.forEach((e) => {
          this.selectCenterGroup.options.push({value: e.id, text: e.name})
        })
      })
    },
    loadDisciplines: function () {
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'getAllDisciplines'
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        this.disciplinesData = response.data
      })
    },
    addDiscipline: function (itemId) {
      this.disciplineTitle = this.$t('LNG_NEW_DISCIPLINE', this.lang)
      this.showDisciplineUpdateError = false
      this.selectedDiscipline = 0
      this.disciplineEditionModal = true
    },
    exitNewDisciplineModal: function () {
      this.disciplineEditionModal = false
      this.showDisciplineUpdateError = false
      this.name = ''
      this.selectLevelGroup.value = null
      this.selectYearGroup.value = null
      this.selectCenterGroup.value = null
      this.selectedDiscipline = 0
    },
    changeStatus: function (itemId) {
      this.showErrorStatusChange = false
      var newStatus
      this.disciplinesData.forEach(function (discipline) {
        if (discipline.id === itemId) {
          if (discipline.disabled === '1') {
            newStatus = '0'
          } else {
            newStatus = '1'
          }
        }
      })

      // Change the status in the db
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'setDisciplineStatus',
          status: newStatus,
          id: itemId
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        if (response.data.status === 'OK') {
          this.disciplinesData.forEach(function (discipline) {
            if (discipline.id === itemId) {
              discipline.disabled = newStatus
            }
          })
        } else {
          this.showErrorStatusChange = true
        }
      })
    },
    createUpdateNewDiscipline: function () {
      this.showDisciplineUpdateError = false
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'createUpdateDiscipline',
          name: this.name,
          level: this.selectLevelGroup.value,
          year: this.selectYearGroup.value,
          center: this.selectCenterGroup.value,
          id: this.selectedDiscipline
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        if (response.data.status === 'OK') {
          this.disciplineEditionModal = false
          this.name = ''
          this.firstname = ''
          this.email = ''
          this.selectedDiscipline = 0
          this.loadDisciplines()
        } else {
          this.updateDisciplineErrorMessage = this.$t(response.data.error, this.lang)
          this.showDisciplineUpdateError = true
        }
      })
    },
    disciplineRowClick: function (data) {
      this.disciplineTitle = this.$t('LNG_EDIT_DISCIPLINE', this.lang)
      this.selectedDiscipline = data.row.id
      this.name = data.row.name
      this.selectLevelGroup.value = data.row.level
      this.selectYearGroup.value = data.row.year
      this.selectCenterGroup.value = data.row.centerId
      this.showDisciplineUpdateError = false
      this.disciplineEditionModal = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<style>
</style>



// WEBPACK FOOTER //
// managementDiscipline.vue?aeeacea2